import { render, staticRenderFns } from "./mailings-form-macros-select.vue?vue&type=template&id=71495485&"
import script from "./mailings-form-macros-select.vue?vue&type=script&lang=js&"
export * from "./mailings-form-macros-select.vue?vue&type=script&lang=js&"
import style0 from "./mailings-form-macros-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports